import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, message } from 'antd';

import ShipmentService from 'services/shipment';
import { PageSpinner } from 'components/page-spinner';
import DetailOrder from 'components/detail-order';
import { errHandling } from 'utils';
import { get } from 'lodash';

export function ShipmentDetail() {
  const [liveTracking, setliveTracking] = useState('');
  const [loadingModal, setLoadingModal] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [orderActivity, setOrderActivity] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tracking, setTracking] = useState([]);
  const [value, setValue] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');

  async function getOrder() {
    try {
      setLoadingPage(true);
      if (id) {
        const { data } = await ShipmentService.getOrderDetail(id);
        const orderDetail = data.data;
        setValue(orderDetail);
        const activity = await ShipmentService.getOrderActivity(id);
        setOrderActivity(activity.data.data);
      }
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingPage(false);
    }
  }

  async function printInvoice() {
    setLoadingPrint(true);
    const { data } = await ShipmentService.getOrderShippingLabel(id);
    const shipping_label = get(data, 'data.shipping_label_url', '');
    setLoadingPrint(false);
    window.open(shipping_label);
  }

  async function findDriver() {
    try {
      setLoadingModal(true);
      await ShipmentService.findDriverGosend(id);
      getOrder();
    } catch (error) {
      errHandling(error);
    } finally {
      setShowModal(false);
      setLoadingModal(false);
    }
  }

  async function getTracking(id) {
    try {
      setLoadingModal(true);
      const { data } = await ShipmentService.getOrderTracking(id);
      const track = data.data;
      setTracking(track.manifest);
      setliveTracking(track.summary.live_tracking_url);
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingModal(false);
    }
  }

  async function confirmDelivery() {
    if (id) {
      try {
        await ShipmentService.confirmDelivery(id);
        await getOrder();
        message.success(
          `Order number ${get(value, 'id', '')} has been delivered`
        );
        navigate('/shipments');
      } catch (err) {
        errHandling(err);
      }
    }
  }

  async function handleShipOrder() {
    try {
      setLoadingModal(true);
      await ShipmentService.shipOrder(id);
      getOrder();
    } catch (error) {
      errHandling(error);
    } finally {
      setShowModal(false);
      setLoadingModal(false);
    }
  }

  const createUpdateTrackHandler = async (key, tracking_code) => {
    if (key === 'create') {
      try {
        await ShipmentService.confirmShipment(id, tracking_code);
        setShowModal(false);
        getOrder();
      } catch (error) {
        errHandling(error);
      }
    } else {
      try {
        await ShipmentService.updateShipment(id, tracking_code);
        setShowModal(false);
        getOrder();
      } catch (error) {
        errHandling(error);
      }
    }
  };

  useEffect(() => {
    getOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (!id) {
      navigate({
        pathname: '/shipments',
      });
    }
  }, [navigate, id]);

  if (loadingPage) {
    return <PageSpinner />;
  }

  return (
    <Layout className="main-container">
      <div className="content">
        <div className="pageTitle">Shipment Detail</div>
        <DetailOrder
          confirmDelivery={confirmDelivery.bind(this)}
          createUpdateTrackHandler={createUpdateTrackHandler}
          findDriver={findDriver.bind(this)}
          getOrder={getOrder.bind(this)}
          getTracking={getTracking}
          handleShipOrder={handleShipOrder.bind(this)}
          id={id}
          isShipment={true}
          liveTracking={liveTracking}
          loadingModal={loadingModal}
          loadingPrint={loadingPrint}
          orderActivity={orderActivity}
          printInvoice={printInvoice.bind(this)}
          setLoadingModal={setLoadingModal}
          setOrderActivity={setOrderActivity}
          setShowModal={setShowModal}
          showModal={showModal}
          tracking={tracking}
          value={value}
        />
      </div>
    </Layout>
  );
}

export default { ShipmentDetail };
